/**
 * Uma página de Game Design em duas abas de temporada — Beta/Season 1 e Season 2+ —,
 * cada aba gravando num documento próprio do servidor.
 *
 * <p>Nasceu em Personagem e virou componente quando "Condições do Personagem" precisou
 * do mesmo desenho (pedido do Theo, 19/08/2026). A regra que vale nas duas: o recorte de
 * temporada É a aba — não há checkbox de entrega por linha.
 *
 * <p><b>O {@code key} na troca de aba não é enfeite:</b> o {@link PaginaDeQuadros}
 * guarda o estado dos quadros de UMA página, e trocar a chave sem remontar gravaria o
 * documento de uma aba na outra.
 */
import { useState } from 'react';
import type { ReactNode } from 'react';

import { PaginaDeQuadros } from './PaginaDeQuadros';
import type { GrupoDeQuadros, SecaoDeQuadros } from './PaginaDeQuadros';
import type { Tabela } from './tabelasEditaveis';

/** O que uma aba precisa: a chave no servidor e o conteúdo de fábrica dela. */
export interface Aba {
  chave: string;
  tabelas: Record<string, Tabela>;
  secoes: Record<string, SecaoDeQuadros>;
  subtitulo: ReactNode;
  grupos?: GrupoDeQuadros[];
}

export function PaginaEmDuasAbas({ beta, season2 }: { beta: Aba; season2: Aba }) {
  const [aba, setAba] = useState<'beta' | 's2'>('beta');
  const atual = aba === 'beta' ? beta : season2;

  const abas = (
    <div className="pq-abas" role="tablist" aria-label="Recorte de temporada">
      <button
        type="button"
        role="tab"
        aria-selected={aba === 'beta'}
        className={aba === 'beta' ? 'pq-aba ativa' : 'pq-aba'}
        onClick={() => setAba('beta')}
      >
        Beta / Season 1
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={aba === 's2'}
        className={aba === 's2' ? 'pq-aba ativa' : 'pq-aba'}
        onClick={() => setAba('s2')}
      >
        Season 2+
      </button>
    </div>
  );

  return (
    <PaginaDeQuadros
      key={atual.chave}
      chave={atual.chave}
      tabelas={atual.tabelas}
      secoes={atual.secoes}
      grupos={atual.grupos}
      abas={abas}
      subtitulo={atual.subtitulo}
    />
  );
}
